import mapData from "./mapData";

const states = mapData.features.map(state => ({
  state_id: state.properties["hc-key"],
  state_name: state.properties.name,
  has_forecast: state.properties.has_forecast || false
}));

states.sort((a, b) => {
  let fa = a.state_name.toLowerCase(),
    fb = b.state_name.toLowerCase();

  if (fa < fb) {
    return -1;
  }
  if (fa > fb) {
    return 1;
  }
  return 0;
});

states.push(
  {
    state_id: "other",
    state_name: "Other states",
    has_forecast: true
  },
);

states.unshift(
  {
    state_id: "all",
    state_name: "Whole of the US",
    has_forecast: true
  }
);

export { states };
